module.exports = __webpack_public_path__ + "img/star4red.bc5ff8ed.png";